(function () {
        var WA_NUMBER = '33687949674';
        var fab = document.getElementById('cb-wa-fab');
        if (!fab) return;

        var path = (window.location.pathname || '').toLowerCase();

        /* 1. Masquer sur checkout */
        if (path.indexOf('/checkout') !== -1) {
          fab.classList.add('cb-wa-hidden');
          return;
        }

        /* 2. Détection page → message adapté */
        var message = 'Bonjour Cocooning Baby, j\'ai une question.';

        /* — Pages "conseil / choix de veilleuse" */
        if (path.indexOf('/pages/quiz') !== -1
            || path.indexOf('/pages/veilleuse-bebe-fille') !== -1
            || path.indexOf('/pages/veilleuse-bebe-garcon') !== -1
            || path.indexOf('/pages/veilleuse-anti-peur-du-noir') !== -1
            || path.indexOf('/pages/veilleuse-allaitement-nuit') !== -1) {
          message = 'Bonjour Cocooning Baby, j\'aimerais un conseil pour choisir la veilleuse de mon bébé.';

        /* — Page cadeau naissance */
        } else if (path.indexOf('/pages/cadeau-naissance') !== -1) {
          message = 'Bonjour Cocooning Baby, j\'aimerais un conseil pour un cadeau de naissance.';

        /* — Pages "Notre histoire / engagements" */
        } else if (path.indexOf('/pages/notre-histoire') !== -1
                || path.indexOf('/pages/nos-engagements') !== -1) {
          message = 'Bonjour Cocooning Baby, j\'ai une question sur la maison.';

        /* — Page livraison & retours */
        } else if (path.indexOf('/pages/politique-de-livraisons-et-retours') !== -1) {
          message = 'Bonjour Cocooning Baby, j\'ai une question sur la livraison ou un retour.';

        /* — Page contact */
        } else if (path.indexOf('/pages/contact') !== -1) {
          message = 'Bonjour Cocooning Baby, j\'aurais besoin de vous joindre.';

        /* — Page FAQ ou autres pages */
        } else if (path.indexOf('/pages/') !== -1) {
          message = 'Bonjour Cocooning Baby, j\'ai une question.';

        /* — Fiches produits spécifiques */
        } else if (path.indexOf('/products/veilleuse-canard-fleur') !== -1 || path.indexOf('/products/daisy') !== -1) {
          message = 'Bonjour Cocooning Baby, j\'ai une question sur la veilleuse Daisy.';
        } else if (path.indexOf('/products/veilleuse-lapin') !== -1 || path.indexOf('/products/bunny') !== -1) {
          message = 'Bonjour Cocooning Baby, j\'ai une question sur la veilleuse Bunny.';
        } else if (path.indexOf('/products/berry') !== -1 || path.indexOf('/products/veilleuse-fraise') !== -1) {
          message = 'Bonjour Cocooning Baby, j\'ai une question sur la veilleuse Berry.';
        } else if (path.indexOf('/products/pearly') !== -1 || path.indexOf('/products/veilleuse-poire') !== -1) {
          message = 'Bonjour Cocooning Baby, j\'ai une question sur la veilleuse Pearly.';
        } else if (path.indexOf('/products/veilleuse-dinosaure') !== -1) {
          message = 'Bonjour Cocooning Baby, j\'ai une question sur la veilleuse Rexy.';
        } else if (path.indexOf('/products/veilleuse-mouton') !== -1) {
          message = 'Bonjour Cocooning Baby, j\'ai une question sur la veilleuse Sheepy.';
        } else if (path.indexOf('/products/veilleuse-canard-couche') !== -1) {
          message = 'Bonjour Cocooning Baby, j\'ai une question sur la veilleuse Coussy.';
        } else if (path.indexOf('/products/veilleuse-peche') !== -1) {
          message = 'Bonjour Cocooning Baby, j\'ai une question sur la veilleuse Peachy.';
        } else if (path.indexOf('/products/') !== -1) {
          message = 'Bonjour Cocooning Baby, j\'ai une question sur l\'une de vos veilleuses.';

        /* — Collections */
        } else if (path.indexOf('/collections/') !== -1) {
          message = 'Bonjour Cocooning Baby, j\'ai une question sur votre collection.';

        /* — Blog / Journal */
        } else if (path.indexOf('/blogs/') !== -1 || path.indexOf('/journal') !== -1) {
          message = 'Bonjour Cocooning Baby, j\'ai une question suite à un article.';

        /* — Homepage */
        } else if (path === '/' || path === '') {
          message = 'Bonjour Cocooning Baby, j\'ai une question.';
        }

        fab.href = 'https://wa.me/' + WA_NUMBER + '?text=' + encodeURIComponent(message);

        /* 3. Décalage sur fiche produit (au-dessus du sticky Add to Cart) */
        if (path.indexOf('/products/') !== -1) {
          fab.classList.add('cb-wa-product');
        }

        /* 4. (Retiré — perf/INP) L'observer childList sur document.body qui re-vérifiait
              un "overlay checkout SPA" est supprimé : sur Shopify le checkout est une
              navigation pleine page (déjà gérée au chargement, étape 1), il n'y a jamais
              d'overlay SPA sur le storefront. Il se déclenchait à chaque mutation du body
              sans utilité → taxe INP permanente sur toutes les pages. */

        /* 5. Cacher le bouton WhatsApp quand un drawer Dawn s'ouvre
              (cart drawer, menu drawer, search overlay). Dawn ajoute la classe
              "overflow-hidden" sur <html> ou <body> à l'ouverture du drawer. */
        var hideOnDrawerOpen = function () {
          var p = (window.location.pathname || '').toLowerCase();
          var isCheckout = p.indexOf('/checkout') !== -1;
          var isOverflowHidden = document.documentElement.classList.contains('overflow-hidden')
                              || document.body.classList.contains('overflow-hidden');
          if (isCheckout || isOverflowHidden) {
            fab.classList.add('cb-wa-hidden');
          } else {
            fab.classList.remove('cb-wa-hidden');
          }
        };
        var drawerObserver = new MutationObserver(hideOnDrawerOpen);
        drawerObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
        drawerObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
        hideOnDrawerOpen();
      })();
